/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = exports.Transparency = exports.StructNullValue = exports.Status = exports.SortOrder = exports.SessionType = exports.LocationsLocationType = exports.LocationStatus = exports.LocationLocationType = exports.DayOfWeek = exports.ConferenceType = exports.CalendarType = exports.ApprovalStatus = void 0;
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["UNDEFINED"] = "UNDEFINED";
    ApprovalStatus["PENDING"] = "PENDING";
    ApprovalStatus["APPROVED"] = "APPROVED";
    ApprovalStatus["DECLINED"] = "DECLINED";
})(ApprovalStatus = exports.ApprovalStatus || (exports.ApprovalStatus = {}));
var CalendarType;
(function (CalendarType) {
    CalendarType["UNDEFINED"] = "UNDEFINED";
    CalendarType["GOOGLE"] = "GOOGLE";
    CalendarType["I_CAL"] = "I_CAL";
    CalendarType["OUTLOOK"] = "OUTLOOK";
    CalendarType["OFFICE_365"] = "OFFICE_365";
})(CalendarType = exports.CalendarType || (exports.CalendarType = {}));
var ConferenceType;
(function (ConferenceType) {
    ConferenceType["UNDEFINED"] = "UNDEFINED";
    ConferenceType["ONLINE_MEETING_PROVIDER"] = "ONLINE_MEETING_PROVIDER";
    ConferenceType["CUSTOM"] = "CUSTOM";
})(ConferenceType = exports.ConferenceType || (exports.ConferenceType = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["UNDEFINED"] = "UNDEFINED";
    LocationLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationLocationType["CUSTOM"] = "CUSTOM";
})(LocationLocationType = exports.LocationLocationType || (exports.LocationLocationType = {}));
var LocationStatus;
(function (LocationStatus) {
    LocationStatus["ACTIVE"] = "ACTIVE";
    LocationStatus["INACTIVE"] = "INACTIVE";
})(LocationStatus = exports.LocationStatus || (exports.LocationStatus = {}));
var LocationsLocationType;
(function (LocationsLocationType) {
    LocationsLocationType["UNKNOWN"] = "UNKNOWN";
    LocationsLocationType["BRANCH"] = "BRANCH";
    LocationsLocationType["OFFICES"] = "OFFICES";
    LocationsLocationType["RECEPTION"] = "RECEPTION";
    LocationsLocationType["HEADQUARTERS"] = "HEADQUARTERS";
})(LocationsLocationType = exports.LocationsLocationType || (exports.LocationsLocationType = {}));
var SessionType;
(function (SessionType) {
    SessionType["UNDEFINED"] = "UNDEFINED";
    SessionType["EVENT"] = "EVENT";
    SessionType["WORKING_HOURS"] = "WORKING_HOURS";
    SessionType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    SessionType["AVAILABILITY"] = "AVAILABILITY";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Status;
(function (Status) {
    Status["UNDEFINED"] = "UNDEFINED";
    Status["CONFIRMED"] = "CONFIRMED";
    Status["CANCELLED"] = "CANCELLED";
})(Status = exports.Status || (exports.Status = {}));
var StructNullValue;
(function (StructNullValue) {
    StructNullValue["NULL_VALUE"] = "NULL_VALUE";
})(StructNullValue = exports.StructNullValue || (exports.StructNullValue = {}));
var Transparency;
(function (Transparency) {
    Transparency["UNDEFINED"] = "UNDEFINED";
    Transparency["FREE"] = "FREE";
    Transparency["BUSY"] = "BUSY";
})(Transparency = exports.Transparency || (exports.Transparency = {}));
var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["FIXED"] = "FIXED";
    Type["CUSTOM"] = "CUSTOM";
    Type["VARIED"] = "VARIED";
})(Type = exports.Type || (exports.Type = {}));
//# sourceMappingURL=types.js.map